
import { Footer, Header, LeftSidebar, Navbar } from "@/components/partials";
import { CommonAPI, Menu } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { Header, Navbar, LeftSidebar, Footer },
  data: () => ({
    menuItems: [] as any,
    applicationId: 0 as number,
  }),
  computed: {
    ...mapGetters(["profile"]),
  },
  watch: {
    applicationId: function (newAppicationID, oldAppicationID) {
      // console.log("newAppicationID::", newAppicationID);
      if (newAppicationID != oldAppicationID) {
        // this.appicationID = newAppicationID;
        this.getAllMenus();
      }
    },
  },
  methods: {
    ...mapActions(["FETCH_PROFILE", "LOGOUT"]),
    getAllMenus: function () {
      const _this = this;
      Menu.getAllMenus(_this.applicationId, localStorage.getItem("version")).then(
        (menus) => {
          _this.menuItems = menus;
          localStorage.setItem("cachedMenus", JSON.stringify(menus));
        }
      );
    },
  },
  mounted: function () {
    // console.log('Master layout component mounted.');
    const _this = this;
    if (!this.profile.hasOwnProperty("name")) this.FETCH_PROFILE();
    const deviceType = localStorage.getItem("deviceType");
    // console.log(deviceType);

    // Retrieve cached menus from localStorage
    const cachedMenus = localStorage.getItem("cachedMenus");
    if (cachedMenus) {
      this.menuItems = JSON.parse(cachedMenus); // Correctly parse the cached menus
    }

    CommonAPI.getApplicationId(deviceType)
      .then((response: any) => {
        _this.applicationId = response.applicationId;
      })
      .catch((error) => {
        console.log(error.response);
      })
      .finally(() => {
        // _this.menuItemjs();
      });
  },
};
